import { buildWaLink } from "../data/menu";
import WaIcon from "./WaIcon";

export const FloatingWhatsApp = () => (
    <a
        href={buildWaLink("Hi Kiraak Mandi! I'd like to place an order.")}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Order on WhatsApp"
        className="wa-pulse fixed bottom-5 right-5 z-50 bg-[#25D366] hover:bg-[#1EBE53] text-white w-14 h-14 md:w-16 md:h-16 rounded-full shadow-2xl flex items-center justify-center transition-transform hover:scale-110"
        data-testid="floating-whatsapp-btn"
    >
        <WaIcon className="w-7 h-7 md:w-8 md:h-8" />
    </a>
);

export default FloatingWhatsApp;
